/*
 * @description: this filter will take a spendLevel object and generate a label for single or combo tiers
 * */
import {
  formatComboTierSpendLevel,
  SpendLevel,
} from '../../../../../../../../../frontend/libs/shared-vanilla/src/index';

// format-combo-tier-spend-level

export type FormatComboTierSpendLevelFilter = (
  spendLevel: SpendLevel,
  truncateValues: boolean,
  useZeroValueLabel: boolean,
  tierName?: string,
  appendTierName?: boolean,
  sizeOfSpendTypeLabel?: 'SHORT_DISPLAY_NAME' | 'DISPLAY_NAME',
  order?: number,
  isPrivate?: boolean,
  isSpendValue?: boolean,
  areRingChartNewRulesEnabled?: boolean,
) => string;

export default function ($filter): FormatComboTierSpendLevelFilter {
  'ngInject';

  const percentFilter = $filter('percentage');
  const numberFilter = $filter('number');

  function currencyFilterWithDefaults(amount: number) {
    return $filter('currency')(amount, '$', 0);
  }

  // All logic for this filter has been moved into the new Angular codebase
  return function (
    spendLevel: SpendLevel,
    truncateValues = false,
    useZeroValueLabel = false,
    tierName?: string,
    appendTierName?: boolean,
    sizeOfSpendTypeLabel?: 'SHORT_DISPLAY_NAME' | 'DISPLAY_NAME',
    order?: number,
    isPrivate = false,
    isSpendValue = false,
    areRingChartNewRulesEnabled = false,
  ): string {
    const formattingOptions = {
      truncateValues,
      useZeroValueLabel,
      tierName,
      appendTierName,
      sizeOfSpendTypeLabel,
      order,
      isPrivate,
      isSpendValue,
      areRingChartNewRulesEnabled,
    };

    return formatComboTierSpendLevel(
      spendLevel,
      formattingOptions,
      currencyFilterWithDefaults,
      percentFilter,
      numberFilter,
    );
  };
}
